import { customerInterface } from 'src/app/util/interfaces/customer';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';

import { LocalityInterface } from 'src/app/util/interfaces/locality';
import { environment } from 'src/environments/environment';
@Injectable({
	providedIn: 'root',
})
export class LocalityService {
	private postLocalitysURL = environment.baseApiUrl + 'location/create';
	private getAllLocalitysURL = environment.baseApiUrl + 'location/search';
	private updateLocalitysURL = environment.baseApiUrl + 'location/update/{id}';
	private deleteLocalitysURL = environment.baseApiUrl + 'location/inactive/{id}';
	private activeLocalitysURL = environment.baseApiUrl + 'location/active/{id}';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	// Buscar por todas localidades
	getAllLocations(): Observable<LocalityInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.getAllLocalitysURL, {
			headers: headers,
		});
	}

	// Buscar localides pelos ID
	getLocalityByID(id: string): Observable<LocalityInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getLocalityByIdURL = this.getAllLocalitysURL + '?id=' + id;
		return this.httpClient.get<any>(getLocalityByIdURL, { headers: headers }).pipe(
			map((interfaceById) => {
				interfaceById = interfaceById[0];
				const newInterface: LocalityInterface = {
					id: interfaceById.id,
					location: interfaceById.location,
					site: interfaceById.site,
					name_site: interfaceById.name_site,
					room: interfaceById.room,
					floor: interfaceById.floor,
					active: interfaceById.active,
					is_stock: interfaceById.is_stock,
					city: interfaceById.city,
					address: interfaceById.address,
					state: interfaceById.state,
					info: interfaceById.info,
				};
				return newInterface;
			})
		);
	}

	// Adiciona uma localidade
	postLocality(locality: LocalityInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		const body = {
			location: locality.location,
			site: locality.site,
			floor: locality.floor,
			room: locality.room,
			city: locality.city,
			address: locality.address,
			state: locality.state,
			info: locality.info,
			is_stock: locality.is_stock ? 1 : 0,
			status: locality.status,
		};
		return this.httpClient.post(this.postLocalitysURL, body, { headers: headers });
	}

	// Atualizar localidades
	updateLocality(customInterface: LocalityInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		const updateLocalitysURL = this.updateLocalitysURL.replace('{id}', customInterface.id);
		const body = {
			location: customInterface.location,
			site: customInterface.site,
			floor: customInterface.floor,
			room: customInterface.room,
			city: customInterface.city,
			address: customInterface.address,
			state: customInterface.state,
			info: customInterface.info,
			is_stock: customInterface.is_stock ? 1 : 0,
		};
		return this.httpClient.put(updateLocalitysURL, body, { headers: headers });
	}

	// Deletar/Desativara localidade
	deleteLocality(customInterface: LocalityInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const deleteLocalityUrl = this.deleteLocalitysURL.replace('{id}', customInterface.id);
		return this.httpClient.delete<any>(deleteLocalityUrl, { headers: headers });
	}

	// Ativa localidade
	activeLocality(customInterface: LocalityInterface): Observable<any> {
		//  let activeLocalityURL = this.activeLocalitysURL.replace('{id}',customInterface.id);
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const activeLocalityURL = this.activeLocalitysURL.replace('{id}', customInterface.id);
		return this.httpClient.get<any>(activeLocalityURL, { headers: headers });
	}
}
